// Business-side API client: public merchant signup + pending-state lookup
// + admin application review.

import axios from 'axios';
import API_BASE_URL from '../config';

const BASE = `${API_BASE_URL}/api`;

function authHeaders(extra = {}) {
  const token = localStorage.getItem('accessToken');
  return {
    Authorization: `Bearer ${token || ''}`,
    'Content-Type': 'application/json',
    ...extra,
  };
}

// ---------- public ----------

// Multipart POST — fields includes document_<slot> File entries.
// Returns the access/refresh JWT so the new merchant lands logged in.
export async function submitMerchantSignup(fields) {
  const form = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v === null || v === undefined || v === '') return;
    form.append(k, v);
  });
  const res = await axios.post(`${BASE}/merchant/signup/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

// Authenticated lookup of the current user's own application.
export async function getMyApplication() {
  const res = await axios.get(`${BASE}/merchant/application/`, { headers: authHeaders() });
  return res.data;
}

// ---------- admin ----------

export async function listApplications({ status = '', q = '', page = 1, pageSize = 50 } = {}) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (q) params.set('q', q);
  params.set('page', page);
  params.set('page_size', pageSize);
  const res = await axios.get(`${BASE}/admin/applications/?${params}`, { headers: authHeaders() });
  return res.data;
}

export async function getApplication(id) {
  const res = await axios.get(`${BASE}/admin/applications/${id}/`, { headers: authHeaders() });
  return res.data;
}

export async function approveApplication(id, adminNotes = '') {
  const res = await axios.post(
    `${BASE}/admin/applications/${id}/approve/`,
    { admin_notes: adminNotes },
    { headers: authHeaders() },
  );
  return res.data;
}

export async function rejectApplication(id, adminNotes) {
  const res = await axios.post(
    `${BASE}/admin/applications/${id}/reject/`,
    { admin_notes: adminNotes },
    { headers: authHeaders() },
  );
  return res.data;
}

export async function requestMoreInfo(id, adminNotes) {
  const res = await axios.post(
    `${BASE}/admin/applications/${id}/request-info/`,
    { admin_notes: adminNotes },
    { headers: authHeaders() },
  );
  return res.data;
}
